import React from "react";
import { withTranslation } from "react-i18next";
import {
  Card, CardBody, CardHeader, CardTitle,
} from "reactstrap";
import {
  Table, Thead, Tbody, Tr, Th, Td
} from "react-super-responsive-table";
import { useDispatch } from "react-redux";
import dedicatedLinks from "./links";
import { showSuccessNotification } from "store/notifications/actions";
import "./DedicatedLinks.css";

const DedicatedLinks = ({ parentRef, agRef, t }) => {
  const dispatch = useDispatch();

  return (
    <Card className="dedicated-links-card">
      <CardHeader className="py-3 border-bottom-0">
        <CardTitle className="mb-0 color-primary">{t("IB Dedicated Links")}</CardTitle>
      </CardHeader>
      <CardBody>
        {!agRef ? (
          <div className="text-center">{t("No Agreements for this account.")}</div>
        ) : (
          <Table className="dedicated-links-table w-100">
            <Thead>
              <Tr>
                <Th className="py-1 not-allowed">{t("Type")}</Th>
                <Th className="py-1 not-allowed">{t("Link")}</Th>
              </Tr>
            </Thead>
            <Tbody>
              {dedicatedLinks.map((link, idx) => {
                const fullLink = `${link.url}?parentRef=${parentRef}&agRef=${agRef}`;
                return (
                  <Tr className="link-row" key={idx}>
                    <Td className="link-type">{t(link.type)}</Td>
                    <Td className="link-url">
                      <a href={fullLink} target="_blank" rel="noopener noreferrer">
                        <span className="url-text">{fullLink}</span>
                      </a>
                      <i
                        className="mdi mdi-content-copy copy-icon"
                        onClick={() => {
                          navigator.clipboard.writeText(fullLink);
                          dispatch(showSuccessNotification("Link copied to clipboard"));
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        )}
      </CardBody>
    </Card>
  );
};

export default withTranslation()(DedicatedLinks);
